import CaseStudyPage from "@/pages/portfolio/components/CaseStudyPage";

export default function EducationCase() {
  return <CaseStudyPage slug="education-platform" />;
}